import React, { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import differenceInMonths from 'date-fns/differenceInMonths';
import format from 'date-fns/format';
import intlFormatDistance from 'date-fns/intlFormatDistance';
import parseISO from 'date-fns/parseISO';
import { Box } from '@daedalus/atlas/helpers/Box';
import { ScoreRating } from '@daedalus/atlas/ScoreRating';
import { Text } from '@daedalus/atlas/Text';
import { Review } from '@findhotel/sapi';
import { DotSeparatedList } from '../DotSeparatedList';
export interface ReviewCommentProps extends Pick<Review, 'reviewerScore' | 'reviewerName' | 'reviewDate'> {
  /** Length of stay */
  lengthOfStay?: number;
  /** Slot to display review source logo if any */
  SourceLogoSlot?: ReactNode;
  /** The logo click handler */
  onSourceLogoClick?: (e: React.SyntheticEvent) => void;
}
const Info = /*#__PURE__*/styled('div')({
  name: "Info",
  class: "i6u4otj",
  propsAsIs: false
});
const SourceLogoWrapper = /*#__PURE__*/styled('div')({
  name: "SourceLogoWrapper",
  class: "s1r6hbf4",
  propsAsIs: false
});
export const ReviewComment: FC<ReviewCommentProps> = ({
  children,
  reviewerScore,
  reviewerName,
  reviewDate,
  lengthOfStay,
  SourceLogoSlot,
  onSourceLogoClick
}) => {
  const {
    formatMessage
  } = useIntl();
  const reviewDateObject = parseISO(reviewDate);
  const now = new Date();
  const displayDate = differenceInMonths(now, reviewDateObject) >= 1 ? format(reviewDateObject, 'd MMM yyyy') : intlFormatDistance(reviewDateObject, now);
  const lengthOfStayString = lengthOfStay ? formatMessage({
    id: 'stayedNights',
    defaultMessage: 'Stayed {nightsCount, plural, one {1 night} other {# nights}}'
  }, {
    nightsCount: lengthOfStay
  }) : '';
  const SubLabel = <DotSeparatedList values={[displayDate, lengthOfStayString]} isSingleLine />;
  return <Box display="flex" flexDirection="column" gap="s300" data-id="hotelReviewsCommentItem">
      <Info>
        <ScoreRating value={reviewerScore} label={reviewerName} subLabel={SubLabel} />
        {!!SourceLogoSlot && <SourceLogoWrapper onClick={onSourceLogoClick}>
            {SourceLogoSlot}
          </SourceLogoWrapper>}
      </Info>
      <Text variant="bodyM">{children}</Text>
    </Box>;
};

require("./ReviewComment.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewComment.tsx");